
import {Component, Prop, Vue} from 'vue-property-decorator'
import {apiShopLists} from '@/api/shop'
import LsUpload from '@/components/ls-upload.vue'
import {apiFileList} from '@/api/app'
import {apiIndustryAdd, apiIndustryDetail, apiIndustryEdit} from '@/api/IndustryRequests'

import {debounce, RequestPaging} from '@/utils/util'
import MaterialSelect from "@/components/material-select/index.vue";

@Component({
  components: {
    MaterialSelect,
    LsUpload
  }
})
export default class ListsDetail extends Vue {
  /** S Data **/
  @Prop({default: 20}) pageSize!: number
  @Prop({default: 'popup'}) mode!: 'pages' | 'popup'
  identity: number | null = null; // 当前编辑用户的身份ID

  currentId = ''
  shopData: any[] = []
  selectList: any[] = []
  pager = new RequestPaging({size: this.pageSize})
  // 添加行业求购表单数据
  form: any = {
    sid: '', // 商城列表
    video_url: "",//累计商品
  };

  get typeValue() {
    return 20
  }

  name = ''
  // 表单校验
  rules = {
    sid: [{ required: true, message: '请选择商城列表', trigger: ['blur', 'change']}],
    // goods: [
    //   { content: true, message: '请输入累计商品', trigger: 'blur' }
    // ],
    // cumulative: [
    //   { required: true, message: '请输入累计求购', trigger: 'blur' },
    // ],
    // buyer: [
    //   { required: true, message: '请输入求购人', trigger: 'blur' },
    //
    // ],
    // tel: [{ required: true, message: '请输入联系电话', trigger: ['blur', 'change'] }],
    content: [{ required: true, message: '请输入内容', trigger: ['blur', 'change'] }]
  };
  getList(): void {
    if (this.mode == 'pages') {
      this.clearSelectList()
    }
    this.pager.request({
      callback: apiFileList,
      params: {
        type: this.typeValue,
        cid: this.currentId,
        name: this.name,
      },
    })

  }

  clearSelectList() {
    this.selectList = []
  }

  // 点击表单提交
  onSubmit(formName: string) {
    // 验证表单格式是否正确
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      this.form.type = 2;
      if (!this.identity) {
        this.handleShopAdd()
      } else {
        this.handleShopEdit()
      }
    })
  }

  // 添加域名输入框
  addDomain() {
    this.form.domain_alias_list.push('')
  }

  // 移除域名输入框
  removeDomain(index: number) {
    if (this.form.domain_alias_list.length > 1) {
      this.form.domain_alias_list.splice(index, 1)
    }
  }

  // 添加行业求购
  async handleShopAdd(): Promise<void> {
    await apiIndustryAdd({...this.form})
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 编辑行业求购
  async handleShopEdit(): Promise<void> {
    await apiIndustryEdit({...this.form, id: this.identity})
    setTimeout(() => this.$router.go(-1), 500)
  }

  //获取商场列表数据
  async getShopListsFn(): Promise<void> {
    const res: any = await apiShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.lists;
  }

  // 获取详情
  async getShopDetailFunc(): Promise<void> {
    const res: any = await apiIndustryDetail({
      id: this.identity as number
    })


    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }


  created() {
    const query: any = this.$route.query

    // 编辑模式：初始化数据
    this.identity = +query.id
    if (+query.id) {
      this.getShopDetailFunc()
    }
    // 获取商城列表是数据
    this.getShopListsFn()
    this.onSubmit = debounce(this.onSubmit, 2000)

  }

  /** E Life Cycle **/
}
